import Celebrity from "@/assets/icons/diet-types/celebrity.svg";
import CustomChoice from "@/assets/icons/diet-types/custom-choice.svg";
import Detox from "@/assets/icons/diet-types/detox.svg";
import Fish from "@/assets/icons/diet-types/fish.svg";
import FishFree from "@/assets/icons/diet-types/fish-free.svg";
import ForMoms from "@/assets/icons/diet-types/for-moms.svg";
import GlutenFree from "@/assets/icons/diet-types/gluten-free.svg";
import Hashimoto from "@/assets/icons/diet-types/hashimoto.svg";
import HighProtein from "@/assets/icons/diet-types/high-protein.svg";
import Immunity from "@/assets/icons/diet-types/immunity.svg";
import IntermittentFasting from "@/assets/icons/diet-types/intermittent-fasting.svg";
import Keto from "@/assets/icons/diet-types/keto.svg";
import LactoseFree from "@/assets/icons/diet-types/lactose-free.svg";
import LowCarbohydrate from "@/assets/icons/diet-types/low-carbohydrate.svg";
import LowFat from "@/assets/icons/diet-types/low-fat.svg";
import LowGlycemicIndex from "@/assets/icons/diet-types/low-glycemic-index.svg";
import Medical from "@/assets/icons/diet-types/medical.svg";
import Multidiet from "@/assets/icons/diet-types/multidiet.svg";
import Paleo from "@/assets/icons/diet-types/paleo.svg";
import Reductive from "@/assets/icons/diet-types/reductive.svg";
import Sirt from "@/assets/icons/diet-types/sirt.svg";
import Sports from "@/assets/icons/diet-types/sports.svg";
import Standard from "@/assets/icons/diet-types/standard.svg";
import Vegan from "@/assets/icons/diet-types/vegan.svg";
import Vegetarian from "@/assets/icons/diet-types/vegetarian.svg";
import type { DietCatalogTagsType } from "../types";

const getDietIcon = (
  tag: DietCatalogTagsType["slug"],
): React.FC<React.SVGProps<SVGElement>> | null => {
  switch (tag) {
    case "CELEBRITY":
      return Celebrity;
    case "CUSTOM_CHOICE":
      return CustomChoice;
    case "DETOX":
      return Detox;
    case "FISH":
      return Fish;
    case "FISH_FREE":
      return FishFree;
    case "FOR_MOMS":
      return ForMoms;
    case "GLUTEN_FREE":
      return GlutenFree;
    case "HASHIMOTO":
      return Hashimoto;
    case "HIGH_PROTEIN":
      return HighProtein;
    case "IMMUNITY":
      return Immunity;
    case "INTERMITTENT_FASTING":
      return IntermittentFasting;
    case "KETO":
      return Keto;
    case "LACTOSE_FREE":
      return LactoseFree;
    case "LOW_CARBOHYDRATE":
      return LowCarbohydrate;
    case "LOW_FAT":
      return LowFat;
    case "LOW_GLYCEMIC_INDEX":
      return LowGlycemicIndex;
    case "MEDICAL":
      return Medical;
    case "PALEO":
      return Paleo;
    case "REDUCTIVE":
      return Reductive;
    case "SIRT":
      return Sirt;
    case "SPORTS":
      return Sports;
    case "STANDARD":
      return Standard;
    case "VEGAN":
      return Vegan;
    case "VEGETARIAN":
      return Vegetarian;
    case "MULTIDIET":
      return Multidiet;
    default:
      return null;
  }
};

export const DietIcon = ({
  tag,
  className,
}: {
  tag: DietCatalogTagsType["slug"];
  className?: string;
}) => {
  const Icon = getDietIcon(tag);
  if (!Icon) return null;
  return <Icon className={className} />;
};
